import SeoLandingTemplate, { SeoLandingPageData } from "@/components/marketing/SeoLandingTemplate";

const page: SeoLandingPageData = {
  path: "/common-interview-mistakes",
  title: "Common Interview Mistakes",
  seoTitle: "Common Interview Mistakes and How to Avoid Them | HiredCoach",
  seoDescription:
    "Avoid common interview mistakes with clear examples, fixes, and a CTA to practice with AI feedback before your next interview.",
  heroEyebrow: "Interview mistakes",
  heroHeadline: "Most interview mistakes feel small - until they cost you",
  heroSubhead:
    "You can have the right experience and still if you sound vague, scattered, or unprepared for basic questions",
  heroPrimaryCta: "Catch this before your interview",
  heroPanelEyebrow: "What usually goes wrong",
  heroPanelTitle: "The mistakes are predictable",
  heroPanelBullets: [
    "Vague answers missing key details",
    "Weak examples that don't relate to the role",
    "Poor and muddled structure",
    "No real practice beforehand making you stumble on your words",
  ],
  heroPanelFooter: "This is what makes good candidates sound average",
  frameworkTitle: "What actually fixes it",
  frameworkBullets: [
    "Swap broad claims for real examples",
    "Give your answer a structure people can follow",
    "Say it out loud - your head doesn't count",
    "Have details ready when they ask 'how?'",
  ],
  exampleTitle: "A very normal bad answer",
  exampleBlocks: [
    "Claim to be a strong leader",
    "Share what you did without sharing any outcomes",
    "Talk about previous office drama",
    "Don't share any mistakes or lessons learned from them",
  ],
  mistakesTitle: "Common mistakes, plain and simple",
  mistakes: [
    "You talk too long and never land the point",
    "You make claims instead of showing proof",
    "You sound surprised by basic questions",
    "You end without a result anyone remembers",
  ],
  mistakesFooter: "The interviewer will be watching the clock eager to move on",
  ctaEyebrow: "Constant Interview Practice",
  ctaTitle: "Catch this before it costs you",
  ctaBullets: [
    "Stop eing vague and tie experience back to the role",
    "Sound confident as you explain your experience",
    "Talk about your outcomes and sound like a professional",
    "Make mistakes in practice, not when it counts",
  ],
  ctaInfoCard: {
    title: "We'll coach you",
    path: "/public-learn",
    description: "Learn the frameworks, then use our mock interview practice to fix the execution.",
  },
  ctaActionTitle: "Practice your answers",
  ctaActionDescription: "Use feedback to catch the stuff that is hard to notice when you are the one talking.",
  relatedTitle: "More interview questions worth actually practicing",
  relatedLinks: [
    {
      title: "Interview Tips",
      path: "/interview-tips",
      description: "Practical interview tips for answering clearly, sounding confident, and avoiding the mistakes that make strong candidates feel unprepared.",
    },
    {
      title: "Behavioral Interview Questions and Answers",
      path: "/behavioral-interview-questions",
      description: "Review common behavioral interview questions, how to answer them well, and how to practice them with AI feedback.",
    },
    {
      title: "Mock Interview Practice",
      path: "/mock-interview-practice",
      description: "Practice mock interviews with AI feedback, sharpen common interview answers, and turn Coach U frameworks into real interview reps.",
    },
  ],
  faqs: [
    { question: "What is the biggest interview mistake?", answer: "Usually vagueness. People hint at value instead of showing it." },
    { question: "Can mock interviews reduce interview mistakes?", answer: "Yes. It catches pacing problems, weak examples, and the gaps you usually miss on your own." },
  ],
};

export default function CommonInterviewMistakesPage() {
  return <SeoLandingTemplate page={page} />;
}
